import type { SelectionList, ValidValueTypes } from '@revelio/iso-utility';

import { normalizeSkillName } from './skill-name-utils';

type CustomSkillListRef = {
  id: string;
  shortName?: string;
  longName?: string;
};

export type MwCustomSkillListMatch = {
  listId: string;
  ref: CustomSkillListRef;
};

export const findMwCustomSkillListItemByName = (
  customSkillLists: SelectionList<ValidValueTypes>[],
  skillName: string
): MwCustomSkillListMatch | null => {
  const target = normalizeSkillName(skillName);

  for (let index = customSkillLists.length - 1; index >= 0; index -= 1) {
    const list = customSkillLists[index];
    if (!list) {
      continue;
    }

    const ref = list.value.find((item) => {
      const shortName =
        typeof item.shortName === 'string' ? item.shortName : undefined;
      const longName =
        typeof item.longName === 'string' ? item.longName : undefined;
      return (
        (shortName && normalizeSkillName(shortName) === target) ||
        (longName && normalizeSkillName(longName) === target)
      );
    });

    if (ref?.id != null) {
      return {
        listId: String(list.id),
        ref: {
          id: String(ref.id),
          shortName:
            typeof ref.shortName === 'string' ? ref.shortName : undefined,
          longName: typeof ref.longName === 'string' ? ref.longName : undefined,
        },
      };
    }
  }

  return null;
};
